// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var loading = Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("loading-container") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("lds-roller") ])(Data_Array.replicate(8)(Halogen_HTML_Elements.div_([  ]))) ]);
module.exports = {
    loading: loading
};
